<template>
  <NormalRegister :image="image" v-if="findAttributeOnSiteInfo('registerType')[0] == 0"
                  class="my-5"/>
  <RegisterWithVerifyCellPhone :image="image" v-else/>
</template>

<script>
import NormalRegister from "./NormalRegister";
import RegisterWithVerifyCellPhone from "./RegisterWithVerifyCellPhone";

export default {
  name: "m-register-1",
  props: {
    image: {
      type: String,
      default: require('../../../assets/login.png')
    }
  },
  components: {NormalRegister, RegisterWithVerifyCellPhone}
}
</script>

<style scoped>

</style>